import {
  ImageScaleView,
  MovieClip,
  QuickViewPool,
  View,
} from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import gsap from 'gsap';

// NOTE: Instantiating pools here can break tests, due to import order issues
let iconPool: QuickViewPool<ImageScaleView>;
let scorePool: QuickViewPool<LangBitmapFontTextView>;
let burstPool: QuickViewPool<MovieClip>;

export function getIconPool() {
  if (!iconPool) {
    iconPool = new QuickViewPool(() => new ImageScaleView({}));
  }
  return iconPool;
}

export function getScorePool() {
  if (!scorePool) {
    scorePool = new QuickViewPool(() => new LangBitmapFontTextView({}));
  }
  return scorePool;
}

export function getBurstPool() {
  if (!burstPool) {
    burstPool = new QuickViewPool(
      () =>
        new MovieClip({
          url: 'assets/ui/shared/animation/impactburst',
        }),
    );
  }
  return burstPool;
}

export async function animateScore(args: {
  superview: View;
  from: { x: number; y: number };
  count: number;
  zIndex: number;
  scale?: number;
}) {
  const scale = args.scale || 1;
  const text = getScorePool().obtainView();

  text.updateOpts({
    superview: args.superview,
    x: args.from.x,
    y: args.from.y,
    size: 60,
    zIndex: args.zIndex,
    align: 'center',
    verticalAlign: 'center',
    centerOnOrigin: true,
    font: 'Title',
    width: 300,
    height: 300,
    localeText: () => `+${args.count}`,
    scale: 0.5 * scale,
    opacity: 0,
  });

  // Spawn
  gsap.to(text.style, {
    opacity: 1,
    scale: 1 * scale,
    duration: 0.3,
    ease: 'back.out',
  });

  // Move up
  gsap.to(text.style, {
    y: args.from.y - 200 * scale,
    duration: 1.5,
    ease: 'linear',
  });

  // Fade out
  await gsap.to(text.style, {
    opacity: 0,
    duration: 0.5,
    ease: 'linear',
    delay: 1,
  });

  text.removeFromSuperview();
  getScorePool().releaseView(text);
}
